import { Controller } from "@hotwired/stimulus";
import Popper from "popper.js";

export default class extends Controller {
  static targets = ["hoverzone"];
  static values = {
    url: String,
    placement: {
      type: String,
      default: "bottom-start",
    },
    offset: {
      type: String,
      default: "0, 0",
    },
  };

  initialize() {
    this.delayedShow = this.delayedShow.bind(this);
    this.delayedHide = this.delayedHide.bind(this);
    this.hide = this.hide.bind(this);
  }

  connect() {
    this.hoverzones = this.hasHoverzoneTarget ? this.hoverzoneTargets : [this.element];
    this.hoverzones.forEach((target) => {
      target.addEventListener("mouseenter", this.delayedShow);
      target.addEventListener("mouseleave", this.delayedHide);
    });
  }

  disconnect() {
    this.hoverzones.forEach((target) => {
      target.removeEventListener("mouseenter", this.delayedShow);
      target.removeEventListener("mouseleave", this.delayedHide);
    });
    this.hide();
  }

  delayedShow() {
    this.clearShowTimeout();
    clearTimeout(this.hideTimeout);
    this.showTimeout = setTimeout(() => this.show(), 250);
  }

  delayedHide() {
    this.clearShowTimeout();
    clearTimeout(this.hideTimeout);
    this.hideTimeout = setTimeout(() => {
      if (!this.mouseEnter) this.hide();
    }, 100);
  }

  clearShowTimeout() {
    clearTimeout(this.showTimeout);
  }

  show() {
    this.hide();

    this.setPopoverContent();

    this.popper = new Popper(this.element, this.popoverContent, {
      placement: this.placementValue,
      modifiers: {
        offset: {
          offset: this.offsetValue,
        },
      },
    });

    this.mouseEnter = false;
    this.popoverContent.addEventListener("mouseenter", () => {
      this.mouseEnter = true;
      clearTimeout(this.hideTimeout);
    });
    this.popoverContent.addEventListener("mouseleave", this.hide);
  }

  hide() {
    this.clearShowTimeout();
    clearTimeout(this.hideTimeout);
    this.popper?.destroy();
    this.popoverContent?.remove();
    this.popper = null;
    this.popoverContent = null;
    this.mouseEnter = false;
  }

  setPopoverContent() {
    let element = document.createElement("div");

    element.innerHTML = `<turbo-frame id="hovercard" src="${this.urlValue}&placement=${this.placementValue}"></turbo-frame>`;
    element.style.zIndex = 2000;
    document.body.appendChild(element);

    this.popoverContent = element;
  }
}
